export const PTXT = {
  fr: {
    tag: "[ MES PROJETS ]", title: "Mes projets", newProject: "Nouveau projet", newFolder: "Nouveau dossier",
    videos: "Vidéos créées", hours: "Heures de montage économisées", hoursTip: (h) => `Estimation : ${h} h de montage à la main par vidéo`,
    search: "Rechercher un titre…", sortDate: "Date", sortName: "Nom", root: "Tous les projets",
    empty: "Aucun projet pour l'instant.", emptyHint: "Lance un nouveau projet : il est sauvegardé automatiquement.", emptyFolder: "Ce dossier est vide.",
    open: "Ouvrir", rename: "Renommer", duplicate: "Dupliquer", move: "Déplacer vers…", remove: "Supprimer", folder: "Dossier",
    exports: (n) => `${n} vidéo${n > 1 ? "s" : ""} exportée${n > 1 ? "s" : ""}`, modified: "Modifié le", at: "à",
    promptFolder: "Nom du dossier :", promptRename: "Nouveau nom :", promptTitle: "Nouveau titre :",
    confirmDelete: (t) => `Supprimer « ${t} » ? Les médias associés seront effacés.`,
    confirmDeleteFolder: (t) => `Supprimer le dossier « ${t} » ? Son contenu remonte d'un niveau.`,
    moveTitle: "Déplacer vers", moveRoot: "Tous les projets", cancel: "Annuler", moved: "Déplacé", created: "Dossier créé", deleted: "Supprimé", duplicated: "Projet dupliqué",
    dropHere: "Déposer ici", results: (n) => `${n} résultat${n > 1 ? "s" : ""}`, noResults: "Aucun projet ne correspond.",
    anon: "Ton projet est enregistré sur cet appareil. Connecte-toi au moment de télécharger pour le retrouver partout.",
  },
  en: {
    tag: "[ MY PROJECTS ]", title: "My projects", newProject: "New project", newFolder: "New folder",
    videos: "Videos created", hours: "Editing hours saved", hoursTip: (h) => `Estimate: ${h} h of manual editing per video`,
    search: "Search a title…", sortDate: "Date", sortName: "Name", root: "All projects",
    empty: "No project yet.", emptyHint: "Start a new project: it is saved automatically.", emptyFolder: "This folder is empty.",
    open: "Open", rename: "Rename", duplicate: "Duplicate", move: "Move to…", remove: "Delete", folder: "Folder",
    exports: (n) => `${n} video${n > 1 ? "s" : ""} exported`, modified: "Edited on", at: "at",
    promptFolder: "Folder name:", promptRename: "New name:", promptTitle: "New title:",
    confirmDelete: (t) => `Delete “${t}”? Its media will be erased.`,
    confirmDeleteFolder: (t) => `Delete folder “${t}”? Its content moves up one level.`,
    moveTitle: "Move to", moveRoot: "All projects", cancel: "Cancel", moved: "Moved", created: "Folder created", deleted: "Deleted", duplicated: "Project duplicated",
    dropHere: "Drop here", results: (n) => `${n} result${n > 1 ? "s" : ""}`, noResults: "No project matches.",
    anon: "Your project is saved on this device. Sign in when you download to find it everywhere.",
  },
};

export const fmtDate = (iso, lang) => {
  const d = new Date(iso);
  const loc = lang === "en" ? "en-GB" : "fr-FR";
  return `${d.toLocaleDateString(loc)} ${lang === "en" ? "at" : "à"} ${d.toLocaleTimeString(loc, { hour: "2-digit", minute: "2-digit" })}`;
};

/* Chemin d'un dossier (fil d'Ariane) depuis la liste plate */
export function folderPath(folders, id) {
  const byId = Object.fromEntries(folders.map((f) => [f.folder_id, f]));
  const out = [];
  let cur = id ? byId[id] : null;
  let guard = 0;
  while (cur && guard++ < 50) { out.unshift(cur); cur = cur.parent_id ? byId[cur.parent_id] : null; }
  return out;
}
